import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { BaseService } from "./base.service";

import { FilmModel } from "../models/film";

import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';

@Injectable()
export class FilmService extends BaseService{
    private uri: string;

    constructor(private http: Http){
        super();
        this.uri = "https://filmstripped.org/api";
    }

    public getApiUri(): string{
        return this.uri;
    }

    getFilm(id: number): Observable<FilmModel>{
        return this.http
            .get(`${this.uri}/Films/${id}`)
            .retry(BaseService.RETRIES)
            .catch(super.catchErrors)
            .map(super.parseResponse);
    }
    
    //Gets a list of all films
    //TODO - make an endpoint
    getFilms(): Observable<FilmModel[]>{
        return this.http
            .get(`${this.uri}/Films`)
            .retry(BaseService.RETRIES)
            .catch(super.catchErrors)
            .map(super.parseResponse)
            .map(super.parseArray);
    }
}



// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/services/film.service.ts